import { Body, VButton, VDialog, VIconActionButton } from '@vrzl/ui';
import { RefreshCw } from 'lucide-react';
import { useState } from 'react';

import { useMe } from '@/domains/sync/api/me';

import { useRetryExtraction } from '../api/mutations';

export function RetryExtractionButton({ eventId }: { eventId: string }) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const retry = useRetryExtraction(eventId);
  const { data: me } = useMe();

  const handleConfirm = () => {
    setConfirmOpen(false);
    retry.mutate();
  };

  if (!me?.isAdmin) return null;

  return (
    <>
      <VIconActionButton
        icon={RefreshCw}
        label="Extractie starten"
        tooltip={
          retry.isPending
            ? 'Extractie wordt gestart…'
            : 'Extractie starten — voert de extractie opnieuw uit op de succesvol geïndexeerde documenten'
        }
        onClick={() => setConfirmOpen(true)}
        disabled={retry.isPending}
        iconClassName={retry.isPending ? 'animate-spin' : undefined}
      />
      {retry.isError && (
        <span className="text-sm text-error-600">
          Starten mislukt. Ververs de pagina en probeer opnieuw.
        </span>
      )}

      <VDialog
        open={confirmOpen}
        onOpenChange={setConfirmOpen}
        size="sm"
        title="Extractie starten?"
        footer={
          <div className="flex justify-end gap-2 px-6 py-4">
            <VButton variant="ghost" size="sm" onClick={() => setConfirmOpen(false)}>
              Annuleren
            </VButton>
            <VButton variant="primary" size="sm" onClick={handleConfirm}>
              Starten
            </VButton>
          </div>
        }
      >
        <div className="px-6 py-4">
          <Body>
            De extractie wordt uitgevoerd met de succesvol geïndexeerde documenten. Documenten
            waarvan de AI-verwerking is mislukt worden overgeslagen. Er worden geen nieuwe
            gegevens opgehaald uit RxMission.
          </Body>
        </div>
      </VDialog>
    </>
  );
}
